<template>
  <div class="article wrapper">
    <!-- <div class="header">
      {{ detail.C_TITLE }}
    </div> -->
    <div class="lect">
      <div class="lect-top">
        <div class="lect-logo" v-if="detail.C_LOGO">
          <img :src="detail.C_LOGO" />
        </div>
        <div class="lect-right">
          <div class="text"><b>嘉宾姓名：</b>{{ detail.C_TITLE }}</div>
          <div class="text"><b>公司：</b>{{ detail.C_ABSTRACT }}</div>
          <div class="text"><b>职位：</b>{{ detail.N_UserDef1 }}</div>
        </div>
      </div>
      <div class="lect-content">
        <van-tabs
          sticky
          v-model="activeName"
          @click="tabClick"
          class="collcard"
        >
          <van-tab title="嘉宾详情" name="a">
            <div class="lect-detail" v-html="detail.C_CONTENT"></div>
          </van-tab>
          <van-tab title="嘉宾日程" name="b">
            <list-loadding :showloadding="showloadding">
              <div class="collcard2" v-if="list && list.length > 0">
                <van-collapse v-model="collactiveNames">
                  <van-collapse-item
                    :title="item.formatdate.date"
                    :name="item.date"
                    v-for="(item, index) in list"
                    :key="index"
                    class="collapse-item"
                  >
                    <meet-timeline
                      :list="item.list"
                      @listevent="listevent"
                      @collect="collect"
                    ></meet-timeline>
                  </van-collapse-item>
                </van-collapse>
              </div>
            </list-loadding>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <footerAct></footerAct>
  </div>
</template>
<script>
import {
  GetArticleById,
  GetArticleListBySId,
  PFBJLetAgenMapById,
  EditCollect,
  GetCollectList,
} from "@/api/index";
import { mapGetters } from "vuex";
import {
  Tab,
  Tabs,
  Image as VanImage,
  Collapse,
  CollapseItem,
  Dialog,
} from "vant";
import meetList from "@/components/meet-list";
import listLoadding from "@/components/listLoadding";
import meetTimeline from "@/components/meet-timeline";
export default {
  data() {
    return {
      content: "",
      id: "",
      title: "嘉宾",
      detail: {},
      list: [],
      activeName: "",
      showloadding: false,
      collactiveNames: [],
    };
  },
  computed: {
    ...mapGetters(["webSiteImageUrl", "userinfo"]),
  },
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [VanImage.name]: VanImage,
    [Dialog.name]: Dialog,
    meetList,
    listLoadding,
    meetTimeline,
  },
  created(e) {
    document.title = this.title;
    let params = this.$route.query;
    if (params) {
      this.id = params.id;
    }
    if (this.id) {
      this.getArticleById();
    }
  },
  methods: {
    GetCollectList() {
      var params = {
        pkey: this.userinfo.FullCardNumber,
      };
      let _this = this;
      GetCollectList(params)
        .then((res) => {
          console.log(res);
          if (res.state == "success") {
            if (res.data) {
              let clists = res.data;
              let agelist = _this.list;
              agelist.map((t) => {
                t.list.map((tt) => {
                  if (clists.find((f) => f.N_ARTICLE_ID == tt.N_ARTICLE_ID)) {
                    tt.isCollect = true;
                  }
                });
              });
            }
          } else {
            res.msg && console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    collect(item) {
      console.log(item);
      var params = {
        aid: item.N_ARTICLE_ID,
        showid: item.N_SHOW_ID,
        subid: item.N_SUBJECT_ID,
        pkey: this.userinfo.FullCardNumber,
        isCollect: !item.isCollect,
      };
      EditCollect(params)
        .then((res) => {
          console.log(res);
          if (res.state == "success") {
            console.log("操作成功");
            item.isCollect = !item.isCollect;
          } else if (res.state == "need") {
            Dialog.alert({
              message: "请报名活动，选购票型并审核或者支付通过后方可收藏",
            });
          } else {
            res.msg && console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    listevent(data) {
      let params = {
        id: data.N_ARTICLE_ID,
        // title: data.C_TITLE,
      };
      this.$router.push({
        path: "meetdetail",
        query: params,
      });
    },
    tabClick(name, title) {
      if (name == "b") {
        this.getListById(this.id);
      }
    },
    getListById(id) {
      let $this = this;
      if (this.$checkTicketLogin()) {
        this.showloadding = true;
        PFBJLetAgenMapById(id)
          .then((res) => {
            $this.showloadding = false;
            let list = res.list;
            if (list && list.length) {
              // list.forEach((item) => {
              //   if (item.C_LOGO)
              //     item.C_LOGO = $this.webSiteImageUrl + item.C_LOGO;
              // });
              $this.list = $this.setAgendasList(list);
              // $this.list = list;
            }

            console.log(list);
          })
          .then(() => {
            $this.GetCollectList();
          })
          .catch((err) => {
            $this.showloadding = false;
            console.log(err);
          });
      }
    },
    setAgendasList(data) {
      let $this = this;
      let result = [];
      data.forEach(function (item, index) {
        let curagenda = result.find((r) => r.date == item.C_DATETIME);
        if (curagenda) {
          item["isCollect"] = false;
          curagenda["list"] = curagenda["list"] || [];
          curagenda["list"].push(item);
        } else {
          let agendas = {};
          agendas["date"] = item.C_DATETIME;
          agendas["formatdate"] = $this.formatDate(item.C_DATETIME);
          agendas["list"] = [];
          item["isCollect"] = false;
          agendas["list"].push(item);
          result.push(agendas);
        }
      });
      console.log("result", result);
      return result;
    },
    getArticleById() {
      let $this = this;
      GetArticleById($this.id)
        .then((res) => {
          if (res.article && res.article["C_LOGO"]) {
            res.article["C_LOGO"] =
              $this.webSiteImageUrl + res.article["C_LOGO"];
          }
          $this.detail = res.article;
          console.log(res);
        })

        .catch((err) => {
          console.log(err);
        });
    },
    formatDate(data) {
      let res = {};
      try {
        let d = new Date(Date.parse(data.replace(/-/g, "/")));
        res.year = d.getFullYear();
        res.month = d.getMonth() + 1;
        res.day = d.getDate();
        res.date =
          d.getFullYear() +
          "-" +
          (res.month < 10 ? "0" + res.month : res.month) +
          "-" +
          (res.day < 10 ? "0" + res.day : res.day);
      } catch {}
      return res;
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ [class*="van-hairline"]::after {
  content: none;
}
/deep/ .van-cell::after,
.van-collapse-item--border::after {
  content: none;
}
/deep/ .van-tabs__nav {
  background: $theme-blue-color;
}
/deep/.collcard2 {
  padding: 15px;
  // background: #f3f4f5;
}
.collcard {
  //   background-image: linear-gradient(#fff,#fff, #f3f4f5);
  //   background-size: 50px;
}
/deep/ .collcard {
  .van-tab {
    color: #fff;
    // font-weight: bold;
  }
  .van-tab--active {
    color: $theme-color;
  }
  .van-tabs__line {
    // height: 8px;
    // width: 60px;
    background: $theme-color;
  }
}

.lect {
  //   padding: 15px;
  .lect-top {
    display: flex;
    background: url('https://iscreg.oss-cn-shanghai.aliyuncs.com/ali6/PFA21/PFAH5/bgbanner.png') no-repeat; 
    background-size: 100%;
    color: #fff;
    padding: 15px;

    .lect-logo {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      background: #ccc;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        flex-shrink: 0;
        object-fit: cover;
      }
    }
    .lect-right {
      flex: 1;
      padding-left: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .text {
        font-size: 13px;
        line-height: 22px;
      }
    }
  }
  .lect-content {
    font-size: 13px;
    // margin-top: 20px;
    // padding-top: 20px;
    .lect-detail {
      padding: 10px;
      white-space: pre-wrap;
      color: $theme-content-color;

      //   background: #fff;
      //   min-height: 100%;
    }
  }
}
.article {
  // background: #fff;
  min-height: 100%;
}
.header {
  // background: #fff;
  color: #fff;
}
</style>